import filterXSS from 'xss';

export function purifyHTML(html: string, whiteList?: Record<string, string[]>) {
  return filterXSS(html, { whiteList });
}
